import InputComponent from "@/src/components/Input/Input";
import { Label, textVariants } from "@/src/components/Text/Text";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/shad/select";
import { Tabs, TabsList, TabsTrigger } from "@/src/components/shad/tabs";
import { P2PComponentsData } from "../../../P2PTrade/types";
import { Button } from "@/src/components/Button/Button";
import { createType } from "..";
import { UseFormReturn } from "react-hook-form";
// import { useEffect } from "react";
// import { isEmpty } from "lodash";
import AppendInput from "@/src/components/PhoneInput/AppendInput";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { TOptions } from "i18next";

interface Props {
  data: P2PComponentsData | undefined;
  form: UseFormReturn<createType>;
  next: () => void;
}

const Step1 = ({ data, form, next }: Props) => {
  const { t } = useTranslation();
  const trans = (key: string, options?: TOptions) =>
    t(`app.p2p.create.${key}`, options);
  const {
    register,
    setValue,
    formState: { errors },
    watch,
  } = form;

  // if (!data) return null;

  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-center justify-between">
        <Tabs
          defaultValue={"buy"}
          onValueChange={(val) => setValue("trans_type", val)}
          className="flex-1"
        >
          <TabsList className="lg:w-1/3 md:w-1/2 w-full">
            <TabsTrigger
              className="data-[state=active]:bg-[#2F60E0] data-[state=active]:text-white flex-1"
              value="buy"
            >
              {trans("tabs.buy")}
            </TabsTrigger>
            <TabsTrigger
              className="data-[state=active]:bg-[#2F60E0] data-[state=active]:text-white flex-1"
              value="sell"
            >
              {trans("tabs.sell")}
            </TabsTrigger>
          </TabsList>
        </Tabs>
        <div className="hidden md:flex space-x-10 mt-3 md:mt-0 ">
          <span className={textVariants({ size: "sm", variant: "link" })}>
            {trans("marketPrice")}:{" "}
            {Number(data?.info.market_price.info).toLocaleString()}
          </span>
          <span className={textVariants({ size: "sm", variant: "link" })}>
            1 USD = {Number(data?.info.current_usd_rate).toLocaleString()}{" "}
            {watch("currency")?.slice(0, 3)}
          </span>
        </div>
      </div>
      <div className="mt-5 grid gap-3 md:gap-6">
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          <div>
            <Label>{trans("form.crypto.label")}</Label>
            <Select
              value={watch("coin")?.toString()}
              onValueChange={(val) => setValue("coin", Number(val))}
            >
              <SelectTrigger className="p-6">
                <SelectValue placeholder="Eg. BTC" />
              </SelectTrigger>
              <SelectContent>
                {data?.info?.coins.map((item) => (
                  <SelectItem value={item?.id.toString()} key={item?.id}>
                    <div className="flex items-center gap-2">
                      <img src={item?.image} className="h-4 w-4" alt="" />
                      <span className="uppercase">{item?.ticker}</span>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <span
              className={cn(
                textVariants({ size: "sm", variant: "link" }),
                "md:hidden"
              )}
            >
              {trans("marketPrice")}:{" "}
              {Number(data?.info.market_price.info).toLocaleString()}
            </span>
            {errors && (
              <span className="text-red-500 text-xs font-medium">
                {errors?.coin?.message}
              </span>
            )}
          </div>
          <div>
            <Label>{trans("form.currency.label")}</Label>
            <Select
              value={watch("currency")}
              onValueChange={(val) => setValue("currency", val)}
            >
              <SelectTrigger className="p-6">
                <SelectValue placeholder="Eg. USD" />
              </SelectTrigger>
              <SelectContent>
                {data?.info?.currencies.map((item) => (
                  <SelectItem
                    value={item?.currency + item?.id.toString()}
                    key={item?.id}
                  >
                    <div className="flex items-center gap-2">
                      <img src={item?.image} className="h-4 w-6" alt="" />
                      <span>
                        {" "}
                        {item?.name} ({item?.currency})
                      </span>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {errors && (
              <span className="text-red-500 text-xs font-medium">
                {errors?.currency?.message}
              </span>
            )}
          </div>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          <AppendInput
            {...register("amount", { valueAsNumber: true })}
            errors={errors?.amount?.message}
            className="p-6"
            label={trans("form.quantity.label")}
            placeholder={trans("form.quantity.placeholder")}
            right={
              <div className="flex items-center justify-center h-full py-3">
                <span className={cn(textVariants(), "text-center")}>
                  {watch("currency")?.slice(0, 3)}
                </span>
              </div>
            }
          />

          <div>
            <InputComponent
              {...register("rate")}
              errors={errors?.rate?.message}
              className="p-6"
              label={trans("form.price.label")}
            />
            <span
              className={cn(
                textVariants({ size: "sm", variant: "link" }),
                "md:hidden"
              )}
            >
              1 USD = {Number(data?.info.current_usd_rate).toLocaleString()}{" "}
              {watch("currency")?.slice(0, 3)}
            </span>
          </div>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          <InputComponent
            {...register("min_order_price")}
            errors={errors?.min_order_price?.message}
            className="p-6"
            label={trans("form.minTransLimit.label")}
            placeholder={`${trans("form.minTransLimit.placeholder", {
              currency: watch("currency")?.slice(0, 3),
            })}`}
          />
          <InputComponent
            {...register("max_order_price")}
            errors={errors?.max_order_price?.message}
            className="p-6"
            placeholder={`${trans("form.maxTransLimit.placeholder", {
              currency: watch("currency")?.slice(0, 3),
            })}`}
            label={trans("form.maxTransLimit.label")}
          />
        </div>

        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          <div>
            <Label>{trans("form.priceType.label")}</Label>
            <Select
              defaultValue={data?.info.price_types[0]}
              value={form.watch("price_type")}
              onValueChange={(val) => setValue("price_type", val)}
            >
              <SelectTrigger className="p-6">
                <SelectValue placeholder="Eg. Fixed" />
              </SelectTrigger>
              <SelectContent>
                {data?.info.price_types.map((item) => (
                  <SelectItem value={item.split(" ")[0]} key={item}>
                    {item}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {errors && (
              <span className="text-red-500 text-xs font-medium">
                {errors?.price_type?.message}
              </span>
            )}
          </div>
          <div>
            <Label>{trans("form.offerTimeLimit.label")}</Label>
            <Select
              defaultValue="30"
              onValueChange={(val) => setValue("offer_time_limit", Number(val))}
            >
              <SelectTrigger className="p-6">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="30">30</SelectItem>
                <SelectItem value="45">45</SelectItem>
                <SelectItem value="60">1</SelectItem>
                <SelectItem value="90">90</SelectItem>
                <SelectItem value="120">120</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
      <div className="md:mt-20 grid  mt-10">
        <Button onClick={next} className="md:px-20 py-3">
          {trans("form.nextButton")}
        </Button>
      </div>
    </div>
  );
};

export default Step1;
